import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import PositiveListService from "src/modules/data-protection/apis/PositiveListService";
import { getPositiveListErrorKey } from "../helpers/apiError";
import { POSITIVE_LIST_QUERY_KEY } from "../helpers/measureList";

const useCreatePositiveListMeasure = ({ softwareId, t, onSuccess } = {}) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (payload) => {
            const service = PositiveListService.getInstance();

            return await service.createMeasure(softwareId, payload);
        },
        onSuccess: (measure) => {
            queryClient.invalidateQueries([POSITIVE_LIST_QUERY_KEY, softwareId]);
            toast(t("Measure created."), { type: "success" });

            if (typeof onSuccess === "function") {
                onSuccess(measure);
            }
        },
        onError: (error) => {
            if (process.env.NODE_ENV === "development") {
                console.error(error);
            }

            toast(
                t(getPositiveListErrorKey(error) || "An error occurred while saving the measure."),
                { type: "error" }
            );
        },
    });
};

export default useCreatePositiveListMeasure;
